module.exports = __webpack_public_path__ + "img/Data-Dark.4e86663.svg";